export const urls = {
    getFinanceConfig: marketCode => `https://api.financeolx.com/options/${marketCode}`
};

export default (state = null, action) => {
    switch (action.type) {
        case 'RECEIVE_FINANCE_CONFIG':
            return action.data;
        default:
            return state;
    }
};
